// src/api/orderApi.js
import api from './index';

// 获取用户的历史订单记录
export const fetchOrderHistory = ({ user_key }) => api.post('/testapi/payment/payment_controller/get_order_history', {
  user_key // 发送 { user_key: "some-user-key-value" }
});

// 获取单个订单详情（可选，视需求添加）
export const fetchOrderById = ({ orderId }) => api.post('/testapi/order/order_controller/get_order_by_id', {
  orderId // 发送 { orderId: "some-order-id" }
});


// 提交售后客服请求（通过邮件发送）
export const sendAfterSaleEmail = ({ orderNo, type, question, desc, email, uid }) => {
  // 参数校验
  if (!orderNo || !type || !question || !desc || !email || !uid) {
    return Promise.reject(new Error('orderNo, type, question, desc, email, and uid are required for after-sale email request'));
  }

  // 构造请求体
  const requestBody = {
    orderNo,  // 订单编号
    type,     // 产品类型
    question, // 问题描述
    desc,     // 详细描述
    email,    // 用户邮箱
    uid,      // 用户ID
  };

  // 发送 POST 请求
  return api.post('/testapi/email/email_controller/send_after_sale_email', requestBody);
};



// 新增：获取免费测试链接（适用于所有类型）
export const fetchTestUrl = ({ user_key, type }) => {
  // 参数校验
  if (!user_key || !type) {
    return Promise.reject(new Error('user_key and type are required for fetching test URL'));
  }

  // 构造请求体
  const requestBody = {
    user_key,  // 用户标识
    type       // 测试类型（如 "grok" 或其他类型）
  };

  // 发送 POST 请求
  return api.post('/testapi/payment/order_controller/get_ai_home_login_url', requestBody);
};


// 新增：获取免费测试链接（适用于所有类型）
export const fetchHomeAIUrl = ({ user_key, type ,host }) => {
  // 参数校验
  if (!user_key || !type || !host) {
    return Promise.reject(new Error('user_key and type are required for fetching test URL'));
  }

  // 构造请求体
  const requestBody = {
    user_key,  // 用户标识
    type,       // 测试类型（如 "grok" 或其他类型）,
    host
  };

  // 发送 POST 请求
  return api.post('/testapi/payment/order_controller/get_ai_home_login_url', requestBody);
};

// https://gpt2you.com/testapi/payment/order_controller/get_gpt_test_url?usertoken=1595854626@qq.com_1741070503791_43_6a763e425d646de162189a9bc2854090&carid=quzh6ui6

export const fetchGPTCarIds = ({ host, usertoken ,checkToken }) => {
  // 参数校验
  if (!host || !usertoken) {
    return Promise.reject(new Error('host and usertoken are required for fetchGPTCarIds'));
  }

  // 构造请求体
  const requestBody = {
    host,      // 当前请求的主域名
    usertoken, // 用户 token
    checkToken
  };

  // 发送 POST 请求
  return api.post('/testapi/gateway/gateway_controller/get_carid_to_user', requestBody);
};



// 新增：获取免费测试链接（适用于所有类型）
export const fetchHomeAIUrlByCarId = ({ user_key, type , carId ,host}) => {
  // 参数校验
  if (!user_key || !type || !carId || !host) {
    return Promise.reject(new Error('user_key and type are required for fetching test URL'));
  }

  // 构造请求体
  const requestBody = {
    user_key,  // 用户标识
    type,       // 测试类型（如 "grok" 或其他类型）
    carId,
    host
  };

  // 发送 POST 请求
  return api.post('/testapi/payment/order_controller/get_ai_home_login_url_by_carid', requestBody);
};

// https://gpt2you.com/testapi/payment/order_controller/get_gpt_test_url?usertoken=1595854626@qq.com_1741070503791_43_6a763e425d646de162189a9bc2854090&carid=quzh6ui6

export const fetchGPTCarIdsByCarId = ({ host, usertoken ,carId }) => {
  // 参数校验
  if (!host || !usertoken  || !carId) {
    return Promise.reject(new Error('host and usertoken are required for fetchGPTCarIds'));
  }


  
  // 构造请求体
  const requestBody = {
    host,      // 当前请求的主域名
    usertoken, // 用户 token
    carId
  };

  // 发送 POST 请求
  // return api.post('/testapi/gateway/gateway_controller/get_carid_to_user_by_carid', requestBody);
  return api.post('/testapi/gateway/gateway_controller/get_carid_to_user_by_carid', requestBody);

};






export const fetchPayURL = ({ user_key,  uid, product_id, domain, channel }) => {
  // 参数校验
  if (!user_key || !uid  || !product_id  || !domain  || !channel) {
    return Promise.reject(new Error('host and usertoken are required for fetchGPTCarIds'));
  }

  // 构造请求体
  const requestBody = {
    user_key,      // 当前请求的主域名
    uid, // 用户 token
    product_id,
    domain,
    channel
  };

  // 发送 POST 请求
  return api.post('/testapi/payment/payment_ali_hk_controller/get_product_pay_url_by_channel', requestBody);
};

